define('modules/overview/player_preview_option_modal',[
  'backbone',
  'jquery',
  '_',
  'moment',
  'text!./player_preview_option_modal_template.html',
  'session',
], function (Backbone, $, _, moment, modal_template, session) {
  'use strict';
  var View = Backbone.View.extend({
    initialize: function (opts) {
      _.extend(this, opts);

      this.model = new Backbone.Model({
        selectedPlayerId: this.playerId,
        selectedPlayerName: this.playerName,
        selectedDateTime: this.getCurrentDateTime(),
        infoText: _.t('previewmodal.body').replace('##', this.playerName),
      });

      this.listenTo(this.model, 'change', this.render);
    },

    hasSidebar: false,

    subViews: [],
    tagName: 'div',
    className: 'player-preview-option-modal',
    template: _.template(modal_template),

    events: {
      'click .js-cancel': 'closeModal',
      'click .js-preview-loop-btn': 'previewLoop',
      'change .js-preview-loop-date-picker': 'changeDateTime',
    },

    render: function () {
      var model = this.model.toJSON();
      this.$el.html(this.template(model));
      return this;
    },

    changeDateTime: function (e) {
      e.preventDefault();
      this.model.set('selectedDateTime', e.currentTarget.value, {
        silent: 'true',
      });
    },

    getCurrentDateTime: function (e) {
      var today = new Date();
      var month = (today.getMonth() + 1).toString();
      var day = today.getDate().toString();
      var year = today.getFullYear().toString();
      var hours = today.getHours().toString();
      var minutes = today.getMinutes().toString();
      var currentDateTime =
        year +
        '-' +
        (month.length < 2 ? '0' + month : month) +
        '-' +
        (day.length < 2 ? '0' + day : day) +
        'T' +
        (hours.length < 2 ? '0' + hours : hours) +
        ':' +
        (minutes.length < 2 ? '0' + minutes : minutes);
      return currentDateTime;
    },

    previewLoop: function () {
      if (!this.model.get('selectedDateTime')) {
        return;
      }

      var date = this.model.get('selectedDateTime').split('T')[0];
      var time = this.model.get('selectedDateTime').split('T')[1];

      this.trigger('remove');
      this.openPreviewLoopModalRef(
        this.model.get('selectedPlayerId'),
        this.model.get('selectedPlayerName'),
        date,
        time
      );
    },

    closeModal: function (e) {
      if (e) {
        e.preventDefault();
      }
      this.trigger('close');
    },

    remove: function () {
      _.each(this.subViews, function (view) {
        if (view && view.remove) {
          view.remove();
        }
      });
      this.$el.off();
      this.$el.empty();
      this.stopListening();
      return this;
    },
  });
  return View;
});

